import type { Weapon } from './Weapon.type'
import { WeaponTypeId } from './WeaponTypeId.enum'

const maxAmmo = 9

export default function createLightTankCannonWeapon(str: number): Weapon {
  return {
    wt_id: WeaponTypeId.TankCannon,
    str,
    maxAmmo,
    ammo: maxAmmo,
    ammops: 1,
    ca: true,
  }
}
